import classes from '../styles/Page.module.scss';
import client from './api/graphql';
import { GET_WHATS_NEW_CONTENT } from './api/graphql/queries';
import MonthlyArticles from '../components/sections/monthlyArticles/MonthlyArticles';
import MoreArticles from '../components/sections/moreArticles/MoreArticles';
import PromotionalBanner from '../components/organisms/promotionalBanner/PromotionalBanner';
import Subfooter from '../components/organisms/subfooter/Subfooter';
import PageHeader from '../components/organisms/pageHeader/PageHeader';
import { redirectedPtAndArToEnglish } from '../utils/functions';

/**
 * Ayoba Web What's New Page
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const WhatsNew = (props) => {
    if (!props) return null;

    /**
     * Section content
     */
    const { whatsNew, aboutUs, landingPages } = props?.data;
    const { read_article_link_text } = whatsNew.data.attributes.ui_elements[0];
    const { chat_banner } = aboutUs?.data?.attributes;
    const { page_header, monthly_articles, more_articles } =
        whatsNew?.data?.attributes;

    /**
     * Custom props object needed for reusable newsroom section
     */

    return (
        <div className={classes.oWhatsNew}>
            <PageHeader {...page_header} />
            <MonthlyArticles data={monthly_articles[0]} ctaText={read_article_link_text} />
            <PromotionalBanner {...chat_banner} />
            <MoreArticles data={more_articles[0]} ctaText={read_article_link_text} />
            <Subfooter {...landingPages} />
        </div>
    );
};

export async function getServerSideProps(context) {
    let locale = context.query?.lang || context.defaultLocale;
    locale = redirectedPtAndArToEnglish(locale)
    const { data } = await client.query({
        query: GET_WHATS_NEW_CONTENT,
        variables: { _locale: locale }
    });

    return {
        props: { data }
    };
}

export default WhatsNew;
